import React from "react";
import { Button } from "@veriff/genoma";

import "./FinishPage.css";

const FinishPage = () => {
    const handleRedirect = () => {
        window.location.href = "https://www.veriff.com/";
    };

    return (
        <div className="general">
            <img src="/logo-loop.gif" alt="veriff-logo-gif" />
            <div className="message">
                <div className="title">Upload done!</div>
                <div className="desc">
                    <p>
                        {" "}
                        All the sessions and files seem to have been uploaded just fine! <br></br>
                        Please wait until we contact you with the next steps.
                    </p>
                </div>
            </div>
            <Button className="button-finish" onClick={handleRedirect}>
                Go to Veriff.com
            </Button>
        </div>
    );
};

export default FinishPage;
